import { CredentialsModel, RefreshTokenModel, UserModel } from 'models';

import request, { Methods } from 'utils/request';
import { EntityService } from 'utils/entityService';
import { TokenType } from 'store/auth';
import { wait } from 'utils/wait';
import { Mock } from 'utils/mockDecorator';
import store from 'store';

class AuthService extends EntityService {
  constructor() {
    super('auth');
  }

  @Mock(() => import('mock/auth').then((m) => m.MOCK_TOKEN))
  async login(credentials: CredentialsModel) {
    return request<TokenType>({
      method: Methods.POST,
      resource: `${this.resource}/login/email`,
      data: credentials,
    });
  }

  @Mock(() => import('mock/auth').then((m) => m.MOCK_PROFILE))
  async getProfile() {
    return request<UserModel>({
      method: Methods.GET,
      resource: `${this.resource}/me`,
    });
  }

  @Mock(() => import('mock/auth').then((m) => m.MOCK_TOKEN))
  async socialLogin(provider: string, accessToken: string, firebase = false) {
    return request<TokenType>({
      method: Methods.POST,
      resource: `${this.resource}/login/${firebase ? 'firebase' : 'social'}`,
      data: {
        provider,
        ...(firebase ? { idToken: accessToken } : { accessToken }),
      },
    });
  }

  @Mock(() => undefined)
  async logout() {
    const { refreshToken } = store.getState().auth;
    return request({
      method: Methods.POST,
      resource: `${this.resource}/logout`,
      data: { refreshToken },
    });
  }

  @Mock(() => import('mock/auth').then((m) => m.MOCK_REFRESH_TOKEN))
  async refreshToken() {
    const { refreshToken } = store.getState().auth;
    return request<RefreshTokenModel>({
      method: Methods.POST,
      resource: `${this.resource}/login/refresh`,
      data: { refreshToken },
    });
  }

  async getConsentUrls() {
    return wait({
      data: {
        privacyPolicy:
          'https://www.gstatic.com/policies/privacy/pdf/20200828/k0fdi77r/google_privacy_policy_hu_eu.pdf',
        termsAndConditions:
          'https://www.gstatic.com/policies/terms/pdf/20200331/ba461e2f/google_terms_of_service_hu_eu.pdf',
      },
    });
  }

  async checkConsent() {
    return wait({ data: { hasNewConsent: false } });
  }
}

export const authService = new AuthService();
